import authentication from "@irati/auth"
import {Team, TeamState} from "@irati/types"
import FeatureFlags from "@perkbox/feature-flags"
import buService from "@irati/billing/services/bu"

import {getAllTeams} from "../../helpers/teams/getAllTeamsForTenant"

export default async function hasMultipleOffices(business = authentication.business()): Promise<boolean> {
  const offices = await officesForTenant(business)
  return currentlySupportedTeamSetups(offices).length > 1
}

export async function officesForTenant(business = authentication.business(), enabled = false, allowSingleBU = false): Promise<Team[]> {
  let offices
  if (enabled) {
    offices = await getAllTeams(business.uuid, TeamState.BillingUnit)
  } else {
    const billingUnits = await buService.list({businessId: business.uuid})
    offices = billingUnits.map((bu) => {
      return {...bu.team, regionId: bu.regionId}
    })
  }

  if (allowSingleBU || offices.length > 1 || !!authentication.apps("admin.billingUnit")) {
    return offices
  }
  return []
}

export function officeForUser(business = authentication.business(), user = authentication.user()): Promise<Team | null> {
  return officesForTenant(business).then((offices) => {
    const billingUnit = offices.find((team) => user.teamIds.find((teamId) => teamId === team.uuid))

    return billingUnit || null
  })
}

export function isOfficeRequiredForUser(business = authentication.business(), user = authentication.user()): Promise<boolean> {
  return Promise.all([officeForUser(business, user), officesForTenant(business)]).then((res) => {
    const userOffice = res[0]
    const tenantOffices = res[1]
    return !userOffice && !!tenantOffices.length
  })
}

function currentlySupportedTeamSetups(teams: Team[]) {
  // currently only show offices if the tenant has teams with perks permissions assigned to them
  return teams.filter((test) => test?.featureFlags?.includes(FeatureFlags.PerksEnabledForTeam))
}
